<template>
  <main class="content">
    <div class="page-wrapper">
      <TopBlock />
      <AppBanner />
      <CardsList />
    </div>
    <div class="page-wrapper page-wrapper_sm">
      <SliderBlock />
      <FaqBlock />
    </div>
  </main>
</template>

<script>
import AppBanner from '@/components/AppBanner.vue'
import CardsList from '@/components/CardsList.vue'
import FaqBlock from '@/components/FaqBlock.vue'
import SliderBlock from '@/components/SliderBlock.vue'
import TopBlock from '@/components/TopBlock.vue'

export default {
  name: 'HomeView',
  components: {
    TopBlock,
    AppBanner,
    CardsList,
    SliderBlock,
    FaqBlock
  }
}
</script>
